export default {
  classTrans: '授業の振替',
  classTransDiff: '料金の異なる振替授業',
  actuallyPrice: '受講料（対象授業）',
  remainingFee: '残りの受講料（現在の授業）',
  refundTotal: '払い戻し合計',
}
